import {TemplateDetailPage} from './index';

export const CreateNewTemplate = () => {
  return (
    <TemplateDetailPage isNew />
  );
};
